import { Subject } from 'rxjs';
import { masterMessageHub, initCustomSource } from '@services/messageHub/instance';
import { WithCodeField } from '@services/messageHub/master/pushSourceManager';
import { getEnv, ENV } from '@utils/getEnv';
import { reportCustomError, reportCustomMetrics, CUSTOM_METRICS } from '@utils/owlReporter';
import establishPushConnection from '../connection/push/establishPushConnection';
import store from '../store';
import { CustomizedShowArrType } from '../api/define';
import initOrderBackgroundTasks from './order';
import initPhfOrderBackgroundTasks from './phfOrder';
import initPoiBackgroundTasks from './poi';

import initPushTasks from './push';

export default () => {
    const hidePushForXBK = store
        .getState()
        .shellCommon.customizedShowArr.includes(CustomizedShowArrType.PUSH_MESSAGE);

    // XBK 无 Push 消息
    if (!hidePushForXBK) {
        const source$ = new Subject<WithCodeField>();
        masterMessageHub.usePushSource(source$);

        if (getEnv() !== ENV.LOCALHOST) {
            establishPushConnection({
                onConnectionOpen: ({ tryCount, openCount }) => {
                    reportCustomMetrics(CUSTOM_METRICS.PUSH_CONNECTION.KEY, 1, {
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.IS_SUCCESS]: 1,
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.TRY_COUNT]: tryCount,
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.OPEN_COUNT]: openCount,
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.INITIATOR]: 'message_hub',
                    });
                },
                onConnectionError: ({ tryCount, openCount, pushToken: token }) => {
                    reportCustomMetrics(CUSTOM_METRICS.PUSH_CONNECTION.KEY, 1, {
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.IS_SUCCESS]: 0,
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.TRY_COUNT]: tryCount,
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.OPEN_COUNT]: openCount,
                        [CUSTOM_METRICS.PUSH_CONNECTION.TAGS.INITIATOR]: 'message_hub',
                    });

                    // 目前没有最大重试次数限制，这里我们暂且认为连续重试 N 次仍失败的情形是有异常的，上报一个 WARN 级别的自定义错误，且在下一次连接成功之前不再上报
                    // FIXME：此处 N 应当可配置化
                    if (tryCount === 2) {
                        reportCustomError({
                            name: 'Push Connection Error',
                            message: 'Push 连接异常',
                            category: 'Push Exception',
                            level: 'WARN',
                            tags: {
                                pushToken: token,
                                initiator: 'message_hub',
                            },
                        });
                    }
                },
                onConnectionClose: ({ openCount, pushToken: token }) => {
                    reportCustomMetrics(CUSTOM_METRICS.PUSH_DISCONNECTION.KEY, 1, {
                        [CUSTOM_METRICS.PUSH_DISCONNECTION.TAGS.OPEN_COUNT]: openCount,
                        [CUSTOM_METRICS.PUSH_DISCONNECTION.TAGS.INITIATOR]: 'message_hub',
                    });
                    reportCustomError({
                        name: 'Push Disconnection',
                        message: 'Push 连接断开',
                        category: 'Push Exception',
                        level: 'WARN',
                        tags: {
                            pushToken: token,
                            initiator: 'message_hub',
                        },
                    });
                },
            }).message$.subscribe(({ originalMesssage: { handlerType, ...rawMessage } }) => {
                source$.next(rawMessage);
            });
        } else {
            // 本地开发环境不建立 Push 连接，可以通过 window.push 模拟发送 Push 消息
            window.push = (message: any) => source$.next(message);
        }
    }

    initCustomSource(masterMessageHub);

    initOrderBackgroundTasks();
    initPhfOrderBackgroundTasks();
    initPoiBackgroundTasks();

    initPushTasks();
};
